import React from 'react';
import classes from './Faq.module.scss';
import Image from 'components/atoms/Image/Image';
import SplitRow from 'components/organisms/SplitRow/SplitRow';
import FullWidthCta from 'components/organisms/FullWidthCta/FullWidthCta';
import faqQuestions from './faqQuestions';
import { MORE, PRIVACY_PROMISE } from 'components/pages/pages';
import PageHeader from 'components/molecules/PageHeader/PageHeader';
import Txt from 'components/atoms/Txt/Txt';
import { useRouter } from 'next/router';
import useScrollToElementId from 'hooks/useScrollToElementId';
import faqImg1 from './assets/faq_img_1.png';
import Heading from 'components/atoms/Heading/Heading';
import FaqAccordion from 'components/molecules/FaqAccordion/FaqAccordion';
import Button from 'components/atoms/Button/Button';

const Faq: React.FC = () => {
  const router = useRouter();
  const hashMatch = router.asPath.match(/#.*/gi);
  const hash = hashMatch ? hashMatch[0] || '' : '';
  const scrollToElementId = useScrollToElementId();

  React.useEffect(() => {
    window.location.hash = hash?.replace('#', '');
    if (hash?.match(/#.+/)) {
      scrollToElementId(hash);
    }
  }, [hash, scrollToElementId]);

  const onFaqNavClick = (key: string) => {
    scrollToElementId(key);
  };

  return (
    <main className={classes.root}>
      <PageHeader title="FAQ's" backHref={MORE.path} />
      <SplitRow
        mobileColumnOrderSwapped
        contentAlignedTop
        isFirstRow
        leftColumn={
          <>
            <Heading level={1}>FAQ&apos;s</Heading>
            <nav className={classes.buttonsContainer}>
              {faqQuestions.map(({ key, heading }) => (
                <Button
                  buttonType="text"
                  key={key}
                  className={classes.filterButton}
                  onClick={() => onFaqNavClick(key)}
                >
                  <Txt>{heading}</Txt>
                </Button>
              ))}
            </nav>
          </>
        }
        rightColumn={<Image src={faqImg1} alt="FAQ's" />}
      ></SplitRow>

      <div className={classes.faqQuestionsWrapper}>
        {faqQuestions.map(({ key, heading, questions }) => (
          <FaqAccordion key={key} id={key} heading={heading} questions={questions} />
        ))}
      </div>

      <FullWidthCta
        title={<Txt>The Qmee Privacy Promise</Txt>}
        ctaText="Tell me more"
        ctaLink={PRIVACY_PROMISE.path}
      >
        At Qmee, we understand the growing concerns around privacy, so check out our promise of
        putting you first.
      </FullWidthCta>
    </main>
  );
};
export default Faq;
